import React, { useState } from 'react'
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import Text from 'antd/es/typography/Text'
import { DATE_FORMAT_DEFAULT } from '../../constants'
import {
  CheckOutlined,
  CloseOutlined,
  SearchOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { yellowPrimary } from '../../color'
import {
  EmptyText,
  TextWrap,
  trimOverlengthString,
} from '../../components/common/CellText'
import { ModalWrapper, StyledTableWrapper } from './MissionCreatePafeStyled'

const ModalIncomingDocumentList = props => {
  const {
    internalDocumentStore,
    onClearDocument,
    onSubmitModal,
    handleCloseModal,
    isVisibleModalIncomingDocument,
    taskStore,
  } = props

  const {
    internalDocumentIncomingSystemList,
    internalDocumentIncomingSystemTotal,
    internalDocumentIncomingSystemPageIndex,
    internalDocumentIncomingSystemPageSize,
    setFilter,
  } = internalDocumentStore

  const { selectedIncomingDocument, setSelectedIncomingDocument } = taskStore

  const [loadingDocument, setLoadingDocument] = useState(false)

  const [formSearch] = Form.useForm()

  const NGAY_DI_WIDTH = 100
  const NGAY_DEN_WIDTH = 120
  const SO_HIEU_WIDTH = 100
  const TRICH_YEU_WIDTH = 220
  const CO_QUAN_BAN_HANH_WIDTH = 200
  const NGUOI_KY_WIDTH = 160

  const columns = [
    {
      title: 'Ngày đi',
      width: NGAY_DI_WIDTH,
      render: record => (
        <Tooltip title={record.outgoing_date}>
          <TextWrap width={NGAY_DI_WIDTH}>
            {moment(record.outgoing_date).format(DATE_FORMAT_DEFAULT)}
          </TextWrap>
        </Tooltip>
      ),
    },
    {
      title: 'Số hiệu',
      width: SO_HIEU_WIDTH,
      render: record => (
        <Tooltip title={record.document_number}>
          <TextWrap width={SO_HIEU_WIDTH}>
            {trimOverlengthString(record.document_number, SO_HIEU_WIDTH)}
          </TextWrap>
        </Tooltip>
      ),
    },
    {
      title: 'Trích yếu',
      width: TRICH_YEU_WIDTH,
      render: record => (
        <Tooltip title={record.title}>
          <TextWrap width={TRICH_YEU_WIDTH}>
            {trimOverlengthString(record.title, TRICH_YEU_WIDTH)}
          </TextWrap>
        </Tooltip>
      ),
    },
    {
      title: 'Cơ quan ban hành',
      width: CO_QUAN_BAN_HANH_WIDTH,
      render: record =>
        record.authority_issued_name ? (
          <Tooltip title={record.authority_issued_name}>
            <TextWrap width={CO_QUAN_BAN_HANH_WIDTH}>
              {record.authority_issued_name}
            </TextWrap>
          </Tooltip>
        ) : (
          <EmptyText>Không có cơ quan ban hành</EmptyText>
        ),
    },
    {
      title: 'Người kí',
      width: NGUOI_KY_WIDTH,
      render: record =>
        record.signer ? (
          <Tooltip title={record.signer}>
            <TextWrap width={NGUOI_KY_WIDTH}>{record.signer}</TextWrap>
          </Tooltip>
        ) : (
          <EmptyText>Không có người kí</EmptyText>
        ),
    },
  ]

  const onChangePagination = async pageIndex => {
    setFilter('internalDocumentIncomingSystemPageIndex', pageIndex - 1)
    setLoadingDocument(true)
    try {
      await internalDocumentStore.getInternalDocumentIncomingSystemList()
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setLoadingDocument(false)
    }
  }

  const rowSelection = {
    onSelect: document => {
      if (selectedIncomingDocument.map(el => el.code).includes(document.code)) {
        setSelectedIncomingDocument(
          selectedIncomingDocument.filter(el => el.code !== document.code)
        )
      } else {
        setSelectedIncomingDocument([
          ...selectedIncomingDocument,
          {
            code: document.code,
            title: document.title,
            document_number: document.document_number,
          },
        ])
      }
    },
    selectedRowKeys: selectedIncomingDocument.map(doc => doc.code),
  }

  const onSelectDocument = document => {
    if (selectedIncomingDocument.map(el => el.code).includes(document.code)) {
      setSelectedIncomingDocument(
        selectedIncomingDocument.filter(el => el.code !== document.code)
      )
    } else {
      setSelectedIncomingDocument([
        ...selectedIncomingDocument,
        {
          code: document.code,
          title: document.title,
          document_number: document.document_number,
        },
      ])
    }
  }

  const handleSearch = async values => {
    setFilter('internalDocumentIncomingListPageIndex', 0)
    setFilter(
      'internalDocumentIncomingSystemFilterByKeyword',
      values.keyword ? values.keyword.trim() : null
    )
    try {
      await internalDocumentStore.getInternalDocumentIncomingSystemList()
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setLoadingDocument(false)
    }
  }

  return (
    <ModalWrapper
      closable={false}
      title={
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 20,
            }}>
            <span>Danh sách văn bản đến</span>
            <Tooltip title={'Đóng'}>
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => {
                  formSearch.resetFields()
                  internalDocumentStore.clearInternalDocumentIncomingSystem()
                  handleCloseModal()
                }}
              />
            </Tooltip>
          </div>

          <Space
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <Popconfirm
              placement="top"
              title={'Bạn có muốn hủy chọn tất cả văn bản?'}
              onConfirm={() => {
                onClearDocument()
                internalDocumentStore.clearInternalDocumentIncomingSystem()
                formSearch.resetFields()
              }}
              okText="Đồng ý"
              cancelText="Không">
              <Button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                icon={<WarningOutlined style={{ color: yellowPrimary }} />}>
                Hủy chọn
              </Button>
            </Popconfirm>
            <Button
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '-5px',
              }}
              icon={<CheckOutlined />}
              type={'primary'}
              onClick={() => {
                formSearch.resetFields()
                internalDocumentStore.clearInternalDocumentIncomingSystem()
                onSubmitModal()
              }}>
              Đồng ý
            </Button>
          </Space>
        </div>
      }
      footer={null}
      width={1100}
      zIndex={999999}
      visible={isVisibleModalIncomingDocument}
      style={{ top: 20 }}>
      <Form form={formSearch} layout={'horizontal'} onFinish={handleSearch}>
        <div
          style={{ display: 'flex', gap: 20, justifyContent: 'space-between' }}>
          <Row gutter={[16, 16]} style={{ flexGrow: 1 }}>
            <Col span={24}>
              <Form.Item
                // label={'Tìm kiếm theo trích yếu hoặc số hiệu: '}
                name={'keyword'}>
                <Input
                  placeholder={'Nhập trích yếu hoặc số hiệu văn bản...'}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{ flex: '0 0 70px' }}>
            <Button
              icon={<SearchOutlined />}
              htmlType={'submit'}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              type={'primary'}>
              Tìm kiếm
            </Button>
          </Form.Item>
        </div>
      </Form>
      <StyledTableWrapper>
        <Table
          rowSelection={rowSelection}
          rowKey={record => record.code}
          columns={columns}
          dataSource={internalDocumentIncomingSystemList}
          pagination={false}
          loading={loadingDocument}
          rowClassName={'ant-row-pointer'}
          onRow={record => {
            return {
              onClick: () => onSelectDocument(record),
            }
          }}
        />
      </StyledTableWrapper>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: '15px 0',
        }}>
        <Pagination
          onChange={e => onChangePagination(e)}
          hideOnSinglePage={true}
          total={internalDocumentIncomingSystemTotal}
          pageSize={internalDocumentIncomingSystemPageSize}
          current={internalDocumentIncomingSystemPageIndex + 1}
          showSizeChanger={false}
          showLessItems
        />
      </div>
    </ModalWrapper>
  )
}

export default inject(
  'internalDocumentStore',
  'commonStore',
  'taskStore'
)(observer(ModalIncomingDocumentList))
